export function exit_stream() {
    // Stream timed out, change button to new stream
    if (!localStorage.getItem("useremail") && document.getElementById("btn-view-stream")) {
        document.getElementById("btn-view-stream").style.display = "none";
    }
}


export async function get_profile(email) {
    try {
      const response = await fetch(`https://sixhats-backend.onrender.com/user_profile/${email}`);
      if (response.ok) {
        const responseData = await response.json();
        console.log("Profile data:", responseData);
        return responseData;
      }
    } catch (error) {
      console.error('Error getting profile:', error);
      return null; // Return null if there's an error
    }
  }
  

export async function fetchItemData(guid, userInputField, loadingIndicator, spinnerOverlay) {
    try {
        const response = await fetch(`https://sixhats-backend.onrender.com/api/item/${guid}`);

        // Check if the response is OK (200-299)
        if (!response.ok) {
            // Handle 404 specifically
            if (response.status === 404) {
                console.error('Item not found. Please check the GUID:', guid);
                if (userInputField) {
                    userInputField.placeholder = 'Item not found! Please try a different GUID.';
                }
            } else {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return; // Exit the function if the item is not found
        }

        // Parse the JSON data from the response
        const responseData = await response.json();

        // Ensure that responseData contains the expected structure
        if (responseData && responseData.responses) {
            document.title = responseData.query; // Set the document title to the query
            const queryInput = document.getElementById('user-input');

            if (queryInput && responseData && responseData.query) {
                queryInput.value = responseData.query;
                updateMetaTags(responseData.query); // Call to update meta tags
            } else {
                queryInput.value = '';
                console.error("Query is undefined in the response data.");
            }
            if (userInputField) {
                userInputField.classList.remove('loading');
                userInputField.style.color = 'black';
            }
            loadingIndicator.style.display = 'none';
            spinnerOverlay.style.display = 'none';
            return { data: responseData.responses, query: responseData.query, expert_responses:responseData.expert_responses};
        } else {
            console.error("Expected data structure not present");
        }
    } catch (error) {
        console.error('Fetch error:', error.message);
        if (userInputField) {
            userInputField.placeholder = 'Error! Try again...';
        }
        document.getElementById('spinner-overlay').style.display = 'none';
    }
}


export async function fetchResponses(query, loadingIndicator, spinnerOverlay, userInputField, navigate) {
    try {
        loadingIndicator.style.display = 'block';
        spinnerOverlay.style.display = 'block';

        // Get the arrow button element
        const arrowButton = document.querySelector('.arrow-button');

        // Change the icon class to fas fa-square
        arrowButton.innerHTML = '<i className="fas fa-square"></i>';
        const response = await fetch(`https://sixhats-backend.onrender.com/query?query=${query}`);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const responseData = await response.json();

        if (responseData && responseData.guid) {
            // Use responseData.guid instead of guid
            const redirectURL = `/?item=${responseData.guid}`;
            navigate(redirectURL, { replace: true });
            window.location.reload();
        } else {
            console.error("Expected data structure not present");
            userInputField.placeholder = 'No GUID returned. Try again...';
        }
        loadingIndicator.style.display = 'none';
        spinnerOverlay.style.display = 'none';
    } catch (error) {
        console.error('Fetch error:', error.message);
        userInputField.placeholder = 'Error! Try again...';
        loadingIndicator.style.display = 'none';
        spinnerOverlay.style.display = 'none';
    }
}
export async function fetchResponsesFromSource(query, source_guid, loadingIndicator, spinnerOverlay, userInputField, navigate) {
    try {
        loadingIndicator.style.display = 'block';
        spinnerOverlay.style.display = 'block';

        // Get the arrow button element
        const arrowButton = document.querySelector('.arrow-button');

        // Change the icon class to fas fa-square
        arrowButton.innerHTML = '<i className="fas fa-square"></i>';
        const response = await fetch(`https://sixhats-backend.onrender.com/query_source?query=${query}&source_guid=${source_guid}`);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const responseData = await response.json();

        if (responseData && responseData.guid) {
            console.log(responseData)
            loadingIndicator.style.display = 'none';
            spinnerOverlay.style.display = 'none';
            for(let resp in responseData.responses){
                if(resp.includes("Sorry") || resp.includes("sorry")){
                    alert("Sorry: the provided source does not answer your query.")
                    return;
                }
            }
            return responseData.guid;
        } else {
            console.error("Expected data structure not present");
            userInputField.placeholder = 'No GUID returned. Try again...';
        }
        loadingIndicator.style.display = 'none';
        spinnerOverlay.style.display = 'none';
    } catch (error) {
        console.error('Fetch error:', error.message);
        userInputField.placeholder = 'Error! Try again...';
        loadingIndicator.style.display = 'none';
        spinnerOverlay.style.display = 'none';
    }
}

export async function tellMeMore(query, lastitem, lastindex, loadingIndicator, spinnerOverlay, navigate) {
    try {
        loadingIndicator.style.display = 'block';
        spinnerOverlay.style.display = 'block';

        const response = await fetch(`https://sixhats-backend.onrender.com/query?query=${query}`);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const responseData = await response.json();
        if (responseData && responseData.guid) {
            // Use responseData.guid instead of guid
            const redirectURL = `/?item=${responseData.guid}&last=${lastitem}&index=${lastindex}`;
            navigate(redirectURL, { replace: true });
            window.location.reload();
        } else {
            console.error("Expected data structure not present");
        }
        loadingIndicator.style.display = 'none';
        spinnerOverlay.style.display = 'none';
    } catch (error) {
        console.error('Fetch error:', error.message);
        loadingIndicator.style.display = 'none';
        spinnerOverlay.style.display = 'none';
    }
}

export async function checkItemExists(guid) {
    try {
        const response = await fetch(`https://sixhats-backend.onrender.com/api/item/${guid}`);
        if (response.ok) {
            const responseData = await response.json();
            // Assuming a valid item has responses
            return responseData && responseData.responses;
        } else {
            console.log("Did not find the item");
            return false;
        }
    } catch (error) {
        console.error('Error checking item:', error);
        return false;
    }
}

export async function get_item_query_from_id(guid) {
    try {
        const response = await fetch(`https://sixhats-backend.onrender.com/api/item/${guid}`);
        if (response.ok) {
            const responseData = await response.json();
            // Assuming a valid item has responses
            return responseData && responseData.query;
        } else {
            console.log("Did not find the item");
            return false;
        }
    } catch (error) {
        console.error('Error checking item:', error);
        return false;
    }
}

export async function get_item_query_from_ids(guid_list) {
    try {
        const response = await fetch(`https://sixhats-backend.onrender.com/api/items`, {
            method: "POST",
            body: JSON.stringify({
                guids: guid_list,
            }),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        });
        if (response.ok) {
            const responseData = await response.json();
            console.log(responseData)
            // Assuming a valid item has responses
            return responseData && responseData.query;
        } else {
            console.log("Did not find the item");
            return false;
        }
    } catch (error) {
        console.error('Error checking item:', error);
        return false;
    }
}

export async function generate_queries(title, keywords, loadingIndicator, spinnerOverlay) {
    try {
        loadingIndicator.style.display = 'block';
        spinnerOverlay.style.display = 'block';
        const response = await fetch(`https://sixhats-backend.onrender.com/generate?topic=${title}&terms=${keywords}`);
        if (response.ok) {
            const responseData = await response.json();
            loadingIndicator.style.display = 'none';
            spinnerOverlay.style.display = 'none';
            return responseData;
        } else {
            console.log("Error getting response");
            loadingIndicator.style.display = 'none';
            spinnerOverlay.style.display = 'none';
            return false;
        }
    } catch (error) {
        console.error('Error generating queries:', error);

        loadingIndicator.style.display = 'none';
        spinnerOverlay.style.display = 'none';
        return false;
    }
}

export async function generate_item(query, userInputField, loadingIndicator, spinnerOverlay) {
    try {
        loadingIndicator.style.display = 'block';
        spinnerOverlay.style.display = 'block';

        const response = await fetch(`https://sixhats-backend.onrender.com/query?query=${query}`);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const responseData = await response.json();

        if (responseData && responseData.guid) {
            loadingIndicator.style.display = 'none';
            spinnerOverlay.style.display = 'none';
            return responseData.guid;
        } else {
            console.error("Expected data structure not present");
            if (userInputField) {
                userInputField.placeholder = 'No GUID returned. Try again...';
            }
            loadingIndicator.style.display = 'none';
            spinnerOverlay.style.display = 'none';
        }
    } catch (error) {
        console.error('Fetch error:', error.message);
        if (userInputField) {
            userInputField.placeholder = 'Error! Try again...';
        }
        loadingIndicator.style.display = 'none';
        spinnerOverlay.style.display = 'none';
    }
}

export async function create_stream(title, privacy = "public", user_list = [], context = null) {
    try {
        // Check if user is logged in
        var email = localStorage.getItem("useremail");

        let request_body = {
            title: title,
            by: email,
            on: new Date().toLocaleString(),
            at: "placeholder",
            privacy: privacy,
            users: user_list,
        }

        if(context){
            request_body.context = context
        }

        console.log(request_body)

        const response = await fetch("https://sixhats-backend.onrender.com/stream", {
            method: "POST",
            body: JSON.stringify(request_body),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        });
        if (response.ok) {
            const responseData = await response.json();
            return responseData && responseData.guid;
        } else {
            console.log("Error getting response");
            return false;
        }
    } catch (error) {
        console.error('Error creating stream:', error);
        return false;
    }
}

export async function joinStream(stream_guid, user_email) {
    try {
      const response = await fetch(`https://sixhats-backend.onrender.com/stream/${stream_guid}/join`, {
        method: "PUT",
        body: JSON.stringify({
          user: user_email,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8"
        }
      });

      if (response.ok) {
        const responseData = await response.json();
        return responseData;
      } else {
        console.log("Error getting response");
        return false;
      }
    } catch (error) {
      console.error('Error updating stream:', error);
      return false;
    }
  }

export async function create_head_stream(query_list) {
    try {
        // Check if user is logged in
        var email = localStorage.getItem("useremail");

        const response = await fetch(`https://sixhats-backend.onrender.com/stream/${email}/head`, {
            method: "POST",
            body: JSON.stringify({
                queries: query_list,
            }),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        });
        if (response.ok) {
            const responseData = await response.json();
            console.log(responseData);
            return responseData && responseData.guid;
        } else {
            console.log("Error getting response");
            return false;
        }
    } catch (error) {
        console.error('Error creating stream:', error);
        return false;
    }
}

export async function update_stream(stream_guid, item_guid, updater = "anonymous", showDialog = true) {
    try {
        const response = await fetch(`https://sixhats-backend.onrender.com/stream/${stream_guid}/item`, {
            method: "PUT",
            body: JSON.stringify({
                item: item_guid,
                by: updater,
            }),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        });

        if (response.ok) {
            const responseData = await response.json();
            return responseData;
        } else {
            console.log("Error getting response");
            return false;
        }
    } catch (error) {
        console.error('Error updating stream:', error);
        return false;
    }
}

export async function unfollow_stream(stream_guid, user_email) {
    try {
        const response = await fetch(`https://sixhats-backend.onrender.com/stream/${stream_guid}/unfollow`, {
            method: "PUT",
            body: JSON.stringify({
                user: user_email,
            }),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        });

        if (response.ok) {
            const responseData = await response.json();
            // Show a dialog box with a success message
            alert("stream unfollowed");
            return responseData;
        } else {
            console.log("Error getting response");
            return false;
        }
    } catch (error) {
        console.error('Error updating stream:', error);
        return false;
    }
}
export async function delete_stream(stream_guid, user_email) {
    try {
        const response = await fetch(`https://sixhats-backend.onrender.com/stream/${stream_guid}/remove`, {
            method: "DELETE",
            body: JSON.stringify({
                by: user_email,
            }),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        });

        if (response.ok) {
            const responseData = await response.json();
            // Show a dialog box with a success message
            alert("stream deleted");
            return responseData;
        } else {
            console.log("Error getting response");
            return false;
        }
    } catch (error) {
        console.error('Error updating stream:', error);
        return false;
    }
}

export async function get_stream(stream_guid) {
    try {
        const response = await fetch(`https://sixhats-backend.onrender.com/stream/${stream_guid}`);
        if (response.ok) {
            const responseData = await response.json();
            return responseData;
        } else {
            console.log("Did not find the item");
            return false;
        }
    } catch (error) {
        console.error('Error checking item:', error);
        return false;
    }
}

export async function get_stream_next(stream_guid, current_index=0) {
    try {
        const response = await fetch(`https://sixhats-backend.onrender.com/stream/${stream_guid}/next?current_index=${current_index}`);
        if (response.ok) {
            const responseData = await response.json();
            return responseData;
        } else {
            console.log("Did not find the item");
            return false;
        }
    } catch (error) {
        console.error('Error checking item:', error);
        return false;
    }
}

export async function get_created_streams(user_email) {
    try {
        const response = await fetch(`https://sixhats-backend.onrender.com/user/${user_email}/created_streams`);
        if (response.ok) {
            const responseData = await response.json();
            return responseData;
        } else {
            console.log("Did not find the item");
            return false;
        }
    } catch (error) {
        console.error('Error checking item:', error);
        return false;
    }
}

export async function get_next_created_streams(user_email) {
    try {
        const response = await fetch(`https://sixhats-backend.onrender.com/user/${user_email}/created_streams`);
        if (response.ok) {
            const responseData = await response.json();
            return responseData;
        } else {
            console.log("Did not find the item");
            return false;
        }
    } catch (error) {
        console.error('Error checking item:', error);
        return false;
    }
}

export async function get_followed_streams(user_email) {
    try {
        const response = await fetch(`https://sixhats-backend.onrender.com/user/${user_email}/followed_streams`);
        if (response.ok) {
            const responseData = await response.json();
            return responseData;
        } else {
            console.log("Did not find the item");
            return false;
        }
    } catch (error) {
        console.error('Error checking item:', error);
        return false;
    }
}

export async function get_created_streams_page(user_email, offset =0) {
    // try {
        const NAMESPACE_URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8'; // UUIDv5 Namespace URL
        /*global uuid*/
        const guid = uuid.v5(user_email, NAMESPACE_URL);

        const response = await fetch(`https://sixhats-backend.onrender.com/created_streams/${guid}/next?user=${user_email}&offset=${offset}&limit=3`);

        if (response.ok) {
            const responseData = await response.json();
            console.log(responseData)
            return responseData;
        } else {
            console.log(response)
            console.log("Did not find the item");
            return false;
        }
    // } catch (error) {
    //     console.error('Error checking item:', error);
    //     return false;
    // }
}
export async function get_followed_streams_page(user_email) {
    try {
        const response = await fetch(`https://sixhats-backend.onrender.com/user/${user_email}/followed_streams`);
        if (response.ok) {
            const responseData = await response.json();
            return responseData;
        } else {
            console.log("Did not find the item");
            return false;
        }
    } catch (error) {
        console.error('Error checking item:', error);
        return false;
    }
}

export function updateMetaTags() {
    // Get the current URL from the address bar
    const currentUrl = window.location.href;

    // Get the current page title
    const currentTitle = document.title;

    // Get the current page description
    const currentDescription = document.querySelector('meta[property="og:description"]').getAttribute('content');

    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    const ogDescription = document.querySelector('meta[property="og:description"]');

    if (ogTitle) ogTitle.setAttribute('content', currentTitle);
    if (ogUrl) ogUrl.setAttribute('content', currentUrl);
    if (ogDescription) ogDescription.setAttribute('content', currentDescription);

    // Update Twitter Card tags
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    const twitterUrl = document.querySelector('meta[name="twitter:url"]');
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');

    if (twitterTitle) twitterTitle.setAttribute('content', currentTitle);
    if (twitterUrl) twitterUrl.setAttribute('content', currentUrl);
    if (twitterDescription) twitterDescription.setAttribute('content', currentDescription);

    // Optionally, update og:image and twitter:image if needed
    const ogImage = document.querySelector('meta[property="og:image"]');
    const twitterImage = document.querySelector('meta[name="twitter:image"]');
    const imageUrl = 'https://www.6hats.ai/6hats.png'; // Replace with dynamic URL if needed

    if (ogImage) ogImage.setAttribute('content', imageUrl);
    if (twitterImage) twitterImage.setAttribute('content', imageUrl);
}

export function reversed(p) {
    if (Array.prototype.toReversed) {
        // If toReversed is availible
        return p.toReversed();
    } else {
        return p.slice().reverse();
    }
}

export function checkForUpdates() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(registration => {
            registration.update();
        });
    }
}

export function clearCacheAndHardReload() {
    if (caches) {
        caches.keys().then(names => {
            for (let name of names) {
                caches.delete(name);
            }
        });
    }
    window.location.reload(true);
}

// Check for updates every 5 minutes
setInterval(checkForUpdates, 5 * 60 * 1000);

// Listen for controllerchange events
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        clearCacheAndHardReload();
    });
}